import httpClient from "httpClient"

const get = () => {
    
    const pathname = '/convenios'
            
    return httpClient.get(pathname)
    
}


const convenios = {
    get,
}

export default convenios

